import useSwr from 'swr'
import { put, post } from 'libs/client/api-service'
import { mapLatestArticlesToArticleItems } from 'libs/utils'

export const createRateArticle = (article, rating) => {
  post(`/jsonapi/v1/article-ratings`, {
    article_id: article.id,
    rating,
  })
}

export const rateArticle = (article, rating, currentRating) =>
  put(`/jsonapi/v1/article-ratings/${article.id}`, {
    article_id: article.id,
    rating,
    old_rating: currentRating,
  })

export const useLatestArticlesByPage = (offset, categorySlug) => {
  let url = `/jsonapi/v1/articles?page[limit]=9&page[offset]=${offset}&sort=-original_created_at`
  if (categorySlug) {
    url += `&filter[category]=${categorySlug}`
  }

  const { data, error } = useSwr(url)

  return {
    articles: data && mapLatestArticlesToArticleItems(data),
    error,
  }
}
